import * as React from 'react';
import { useMsal } from "@azure/msal-react";

interface ContextType {
    msalFetch: (url: string, options?: any) => Promise<Response>;
    msalFetchResponseOk: (url: string, options?: any) => Promise<Response>;
    hasAccounts: () => boolean;
}

type MsalProviderProps = { children: React.ReactNode };

export const MsalContext = React.createContext<ContextType>({
    msalFetch: () => { throw Error('Cannot use context without provider'); },
    msalFetchResponseOk: () => { throw Error('Cannot use context without provider'); },
    hasAccounts: () => { throw Error('Cannot use context without provider'); }
});

export default function MsalAuthProvider({ children }: MsalProviderProps) {
    const { instance, accounts } = useMsal();
    
    const hasAccounts = () => {
        return accounts.length > 0;
    }

    const msalFetch = async (url: string, options?: any) => {
        const request = {
            scopes: [`df054d84-626c-4c80-9657-659c6a7a7d94/.default`],
            account: accounts[0]
        };

        // Silently acquires an access token
        let accessToken = '';
        try {
            const response = await instance.acquireTokenSilent(request);
            accessToken = response.accessToken;
        } catch (e) {
            console.log(e);
        }

        options = options || {};

        if (!options.headers) {
            options.headers = { 'Authorization': 'Bearer ' + accessToken };
        }
        else {
            options.headers.Authorization = 'Bearer ' + accessToken;
        }

        return fetch(url, options);
    }

    const msalFetchResponseOk = async (url: string, options?: any) => {
        const response = await msalFetch(url, options);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response;
    }

    return (
        <MsalContext.Provider value={{ msalFetch, msalFetchResponseOk, hasAccounts }}>
                    {children}
        </MsalContext.Provider>
    );
}